import { HandlersCollection } from '@tblabs/truffle';
import { BlobPicture } from '../../Models/BlobPicture';
import { DeviceSettingsForWatcher, DeviceConfigForWatcher } from '../../Models/DeviceConfig';
import { BlobUtils } from '../../Utils/BlobUtils';
import { ConnectionStatusEvent } from '../ConnectionStatusEvent';
import { CameraDemoPicsProvider } from '../DemoStuff/CameraDemoPicsProvider';
import { InputState } from '../../Models/SensorState';
import { ICamera } from './ICamera';
import { IoState } from './IoState';


export class DemoCamera implements ICamera
{
    public IoState: IoState = { InputsState: {}, InputsMalfunction: [], OutputsState: {} };
    public OnIoStateChange = new HandlersCollection<(ioState: IoState) => void>();
    public DeviceId = "DEMO";
    public OnMalfunction = new HandlersCollection<(reason: string) => void>();
    public OnInputMalfunction = new HandlersCollection<(inputName: string) => void>();
    public IsHalted: boolean = false;
    public Config: DeviceConfigForWatcher;
    public OnConnectionChange = new HandlersCollection<(event: ConnectionStatusEvent) => void>();
    public OnConfigReceived = new HandlersCollection<(config: DeviceConfigForWatcher) => void>();
    public OnNewPicture = new HandlersCollection<(picture: BlobPicture) => void>();
    public OnInputChange = new HandlersCollection<(state: InputState) => void>();

    private fotoInterval: NodeJS.Timeout | null = null;
    private inputInterval: NodeJS.Timeout | null = null;

    private Log(...msg)
    {
        // console.log('[Camera demo]', ...msg);
    }

    public SetOutput(name: string, state: number): void
    { }

    public async Init(): Promise<void>
    {
        this.Log('Symulating camera...');

        // Symulate connect event
        this.OnConnectionChange.Call(new ConnectionStatusEvent(true));

        // Symulate config event
        const config: DeviceConfigForWatcher = {
            ...this.Config,
            DeviceId: this.DeviceId,
            Halt: this.IsHalted,
            Picture: { Name: "optimal+", Width: 1200, Height: 900, Brightness: 75, Contrast: 82 },
            Hardware: { InputsNames: ["DemoInput1", "DemoInput2"] }
        };
        this.OnConfigReceived.Call(config);

        // Symulate receiving pictures
        const demoPicsProvider = new CameraDemoPicsProvider();
        const demoPics: string[] = await demoPicsProvider.Get();

        if (demoPics.length === 0)
        {
            this.Log('No demo pics found');
            return;
        }

        const picsCache = new Map<string, Blob>();

        let i = 0;
        const picture = new BlobPicture(await BlobUtils.ImageFromUrlToBlob(demoPics[i]));
        picture.IndexFromDevice = i + 1;
        picsCache.set(demoPics[i], picture.Image);
        this.Log(`Emiting picture #${i}`);
        this.OnNewPicture.Call(picture);
        i++;
        let c = 0;
        this.fotoInterval = setInterval(async () =>
        {
            if (this.IsHalted)
                return;

            const picture = new BlobPicture(picsCache.get(demoPics[i]) || await BlobUtils.ImageFromUrlToBlob(demoPics[i]));
            picture.IndexFromDevice = i + 1;
            picsCache.set(demoPics[i], picture.Image);
            this.Log(`Emiting picture #${i}`);
            this.OnNewPicture.Call(picture);
            i++;
            i %= demoPics.length;
        }, 1300);

        // Symulate receiving inputs
        if (config.Hardware?.InputsNames && config.Hardware.InputsNames.length > 0)
            this.inputInterval = setInterval(() =>
            {
                c++;
                if (c == 10)
                    this.OnInputChange.Call(new InputState("DemoInput1", 1));
                if (c == 14)
                    this.OnInputChange.Call(new InputState("DemoInput1", 0));
                if (c == 22)
                    this.OnInputChange.Call(new InputState("DemoInput2", 1));
                if (c == 28)
                    this.OnInputChange.Call(new InputState("DemoInput2", 0));
                if (c == 30)
                    c = 0;
            }, 300);
    }

    public UpdateSettings(settings: DeviceSettingsForWatcher): void
    { }

    public Halt(): void
    {
        this.IsHalted = true;
    }

    public Unhalt(): void
    {
        this.IsHalted = false;
    }

    public Destroy(): void
    {
        if (this.fotoInterval)
            clearInterval(this.fotoInterval);
        if (this.inputInterval)
            clearInterval(this.inputInterval);
    }
}
